var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "146px",
    height: "87px",
    viewBox: "0 0 146 87",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloud") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M123.556,35.55 C135.9116,37.683 145.36,47.637 145.36,60.435 C145.36,73.944 133.7312,85.32 119.922,85.32 C106.8396,85.32 36.34,85.32 25.438,85.32 C11.6288,85.32 0,73.944 0,61.146 C0,48.348 9.4484,37.683 21.804,36.261 C21.804,35.55 21.804,35.55 21.804,35.55 C21.804,15.642 37.7936,0 58.144,0 C70.4996,0 82.1284,6.399 88.6696,16.353 C91.5768,14.931 94.484,14.22 98.118,14.22 C111.2004,14.22 122.1024,23.463 123.556,35.55 Z M73.6689436,47.8306016 L61.7333997,35.7065599 C60.6347186,34.5905273 58.8217639,34.5594852 57.6842063,35.637228 C56.5464887,36.7149681 56.5148463,38.4932108 57.6135274,39.6092434 L69.5492284,51.7334448 L57.1892888,63.4416467 C56.0515712,64.5193868 56.0199288,66.2976295 57.1186099,67.4136621 C58.2172938,68.5295378 60.0302485,68.5605799 61.1678034,67.482994 L73.5274231,55.7747865 L85.4631241,67.8989879 C86.5618081,69.0148636 88.3747628,69.0459057 89.5123176,67.9683198 C90.6500352,66.8905797 90.6816776,65.112337 89.5829965,63.9963044 L77.6472954,51.872103 L90.0070751,40.1638983 C91.1447899,39.0863151 91.1764351,37.3079156 90.077754,36.1918829 C88.9790729,35.0758503 87.1662781,35.044811 86.0285605,36.1225511 L73.6689436,47.8306016 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "No-Connection",
    transform: "translate(-115.000000, -220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(64.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(51.320000, 0.760000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icCloud",
    fillOpacity: 0.6,
    fill: "#666666",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloud);
export default __webpack_public_path__ + "static/media/icCloud.dd83aeaa43b517c548d48e7571ce2a59.svg";
export { ForwardRef as ReactComponent };